import { NativeModules, Platform } from 'react-native'

const { ConfigModule } = NativeModules

const VERSION_NAME = (Platform.OS !== 'web' && ConfigModule && ConfigModule.VERSION) || '1.4.11'

const SERVER_PREFIXES = {
  re7: 'https://viper-v2.int.cardiweb.com',
  preprod: 'https://preprod.viper-v2.viparis.cardicloud.com',
  release: 'https://www.viparis-viper.com',
}

const LINKS = {
  cgu: 'https://www.viparis-viper.com/public/conditions-generales-utilisation_{{lang}}.pdf',
  cookies: 'https://www.viparis-viper.com/public/politique-cookie-groupe-viparis_{{lang}}.pdf',
  who: 'https://www.viparis.com/{{lang}}/qui-sommes-nous',
  legal: 'https://www.viparis-viper.com/public/mentions-legales_{{lang}}.pdf',
  confidentiality: 'https://www.viparis-viper.com/public/politique_de_confidentialite_{{lang}}.pdf',
}

const HOTLINE_PHONE = '0172721111'

const ENV: Env = (ConfigModule && ConfigModule.ENV) || (Platform.OS === 'web' && (window as EnvWindow).env) || 'dev'

const VERSION_PREFIX = '/services/v1'
const PUBLIC_VERSION_PREFIX = '/services/public/v1'
const QUARTZ_PREFIX = '/actuator/quartz/jobs'

const CommonConfig: CommonConfig = {
  ws: {
    authentification: {
      refresh: `${PUBLIC_VERSION_PREFIX}/login/token`,
      login: `${PUBLIC_VERSION_PREFIX}/login/token`,
      me: `${VERSION_PREFIX}/users/me`,
      guest: `${PUBLIC_VERSION_PREFIX}/login/guest`,
      ssoInfo: `${PUBLIC_VERSION_PREFIX}/login/sso/marketplace`,
      ssoToken: `${PUBLIC_VERSION_PREFIX}/login/sso/marketplace`,
      forgottenPassword: `${PUBLIC_VERSION_PREFIX}/login/password-reset`,
      resetPassword: `${PUBLIC_VERSION_PREFIX}/login/password-reset`,
      verifyResetPasswordToken: `${PUBLIC_VERSION_PREFIX}/login/password-reset/verify-token`,
    },
    users: {
      all: `${VERSION_PREFIX}/users`,
      get: `${VERSION_PREFIX}/users/{userId}`,
      me: `${VERSION_PREFIX}/users/me`,
      create: `${VERSION_PREFIX}/users`,
      update: `${VERSION_PREFIX}/users/{userId}`,
      updateUser: `${VERSION_PREFIX}/users/me`,
      signature: `${VERSION_PREFIX}/users/me/signature`,
      export: `${VERSION_PREFIX}/users/export/xlsx`,
      filtre: `${VERSION_PREFIX}/filtres/users`,
    },
    site: {
      all: `${VERSION_PREFIX}/sites`,
      get: `${VERSION_PREFIX}/sites/{id}`,
    },
    manifestation: {
      all: `${VERSION_PREFIX}/manifestations`,
      get: `${VERSION_PREFIX}/manifestations/{id}`,
    },
    localisation: {
      all: `${VERSION_PREFIX}/localisations`,
    },
    famille: {
      all: `${VERSION_PREFIX}/familles`,
    },
    locatairePermanent: {
      all: `${VERSION_PREFIX}/locataires-permanents`,
      get: `${VERSION_PREFIX}/locataires-permanents/{id}`,
    },
    societe: {
      all: `${VERSION_PREFIX}/societes`,
      get: `${VERSION_PREFIX}/societes/{id}`,
      export: `${VERSION_PREFIX}/societes/export/xlsx`,
    },
    commande: {
      all: `${VERSION_PREFIX}/commandes`,
      expo: `${VERSION_PREFIX}/commandes/exposant-non-connecte`,
    },
    incident: {
      // creation
      comment: `${VERSION_PREFIX}/incidents/{incidentId}/commentaires`,
      addFile: `${VERSION_PREFIX}/incidents/{incidentId}/commentaires/{commentaireId}/piece-jointes`,
      addImage: `${VERSION_PREFIX}/incidents/{incidentId}/image`,
      create: `${VERSION_PREFIX}/incidents/creation`,

      // lecture
      all: `${VERSION_PREFIX}/incidents`,
      get: `${VERSION_PREFIX}/incidents/{id}`,
      getExpo: `${VERSION_PREFIX}/incidents/exposant-non-connecte`,
      search: `${VERSION_PREFIX}/incidents/filtre`,
      comments: `${VERSION_PREFIX}/incidents/{id}/commentaires`,
      created: `${VERSION_PREFIX}/incidents/cree`,
      followed: `${VERSION_PREFIX}/incidents/suivi`,

      // export
      exportXLSX: `${VERSION_PREFIX}/incidents/filtre/export/xlsx`,
      exportPDF: `${VERSION_PREFIX}/incidents/filtre/export/pdf`,

      // cycle de vie
      abandon: `${VERSION_PREFIX}/incidents/{incidentId}/abandon`,
      accept: `${VERSION_PREFIX}/incidents/{incidentId}/accepter`,
      affect: `${VERSION_PREFIX}/incidents/{incidentId}/affectation-technicien`,
      askQuote: `${VERSION_PREFIX}/incidents/{incidentId}/demande-devis`,
      sendQuote: `${VERSION_PREFIX}/incidents/{incidentId}/envoie-devis`,
      closePrestataire: `${VERSION_PREFIX}/incidents/{incidentId}/fermeture-prestataire`,
      closeViparis: `${VERSION_PREFIX}/incidents/{incidentId}/fermeture-viparis`,
      acceptPrestataire: `${VERSION_PREFIX}/incidents/{incidentId}/prise-en-charge`,
      restart: `${VERSION_PREFIX}/incidents/{incidentId}/reouverture`,
      treat: `${VERSION_PREFIX}/incidents/{incidentId}/traitement-devis`,
      validate: `${VERSION_PREFIX}/incidents/{incidentId}/valider-incident`,
      inaccessibleStand: `${VERSION_PREFIX}/incidents/{incidentId}/stand-inaccessible`,
      reassignProvider: `${VERSION_PREFIX}/incidents/{incidentId}/reaffectation-societe-prestataire`,

      // suivi
      follow: `${VERSION_PREFIX}/incidents/{incidentId}/suivi`,
      unfollow: `${VERSION_PREFIX}/incidents/{incidentId}/suivi`,

      //statistiques
      stats: `${VERSION_PREFIX}/incidents/statistiques`,

      // historique
      history: `${VERSION_PREFIX}/incidents/{incidentId}/historique`,

      // filtres
      societes: `${VERSION_PREFIX}/filtres/incident/societes`,
    },
    files: {
      get: `${VERSION_PREFIX}/files/{fileId}`,
    },
    notification: {
      token: `${VERSION_PREFIX}/token-push`,
      getPreferences: `${VERSION_PREFIX}/preference-notification`,
      updatePreferences: `${VERSION_PREFIX}/preference-notification`,
    },
    plan: {
      create: `${VERSION_PREFIX}/plan/{localisationId}`,
      update: `${VERSION_PREFIX}/plan/{localisationId}`,
      get: `${VERSION_PREFIX}/plan/byLocalisation/{localisationId}`,
      all: `${VERSION_PREFIX}/plan/bySite/{siteId}`,
    },
    edl: {
      all: `${VERSION_PREFIX}/etat-des-lieux`,
      get: `${VERSION_PREFIX}/etat-des-lieux/{id}`,
      incidents: `${VERSION_PREFIX}/etat-des-lieux/incidents/filtre`,
      send: `${VERSION_PREFIX}/etat-des-lieux`,
      downloadXLSX: `${VERSION_PREFIX}/etat-des-lieux/export/xlsx`,
      downloadPDF: `${VERSION_PREFIX}/etat-des-lieux/pdf`,
      sync: `${VERSION_PREFIX}/etat-des-lieux/{id}/sync/magic`,
    },
    roles: {
      all: `${VERSION_PREFIX}/roles`,
      create: `${VERSION_PREFIX}/roles`,
      update: `${VERSION_PREFIX}/roles/{roleId}`,
      delete: `${VERSION_PREFIX}/roles/{roleId}`,
      scopes: `${VERSION_PREFIX}/roles/scopes`,
    },
    quartz: {
      all: `${QUARTZ_PREFIX}/DEFAULT`,
    },
    controle: {
      all: `${VERSION_PREFIX}/controle-qualite/filtre`,
      get: `${VERSION_PREFIX}/controle-qualite/{controleQualiteId}`,
      delete: `${VERSION_PREFIX}/controle-qualite/{controleQualiteId}`,
      create: `${VERSION_PREFIX}/controle-qualite`,
      exportXLSX: `${VERSION_PREFIX}/controle-qualite/{controleQualiteId}/export/xlsx`,
      exportPDF: `${VERSION_PREFIX}/controle-qualite/{controleQualiteId}/export/pdf`,
      metier: `${VERSION_PREFIX}/controle-qualite/metiers`,
      question: `${VERSION_PREFIX}/controle-qualite/questions`,
      stats: `${VERSION_PREFIX}/controle-qualite/statistiques`,
      historique: `${VERSION_PREFIX}/controle-qualite/statistiques/historiques`,
      filtres: {
        espace: `${VERSION_PREFIX}/filtres/controle-qualite/espaces`,
        manifestation: `${VERSION_PREFIX}/filtres/controle-qualite/manifestations`,
        metier: `${VERSION_PREFIX}/filtres/controle-qualite/metiers`,
        societe: `${VERSION_PREFIX}/filtres/controle-qualite/societes`,
      },
    },
    help: { tutorials: `${VERSION_PREFIX}/tutorials` },
    contacts: { all: `${VERSION_PREFIX}/contacts` },
  },
}

const EnvConfig = (env: Env): EnvConfig => {
  switch (env) {
    case 'dev':
      return {
        SERVER_PREFIX: Platform.OS === 'web' ? '' : SERVER_PREFIXES.re7,
        DELETE_ACCOUNT_MAIL: 'testEnDev@cardiweb.com',
        logLevel: 'debug',
      }
    case 're7':
      return {
        SERVER_PREFIX: Platform.OS === 'web' ? '' : SERVER_PREFIXES.re7,
        DELETE_ACCOUNT_MAIL: 'testEnRecette@cardiweb.com',
        logLevel: 'info',
      }
    case 'preprod':
      return {
        SERVER_PREFIX: Platform.OS === 'web' ? '' : SERVER_PREFIXES.preprod,
        DELETE_ACCOUNT_MAIL: 'testEnPreprod@cardiweb.com',
        logLevel: 'warn',
      }
    case 'release':
      return {
        SERVER_PREFIX: Platform.OS === 'web' ? '' : SERVER_PREFIXES.release,
        DELETE_ACCOUNT_MAIL: 'dataprotection@viparis.com',
        logLevel: 'warn',
      }
    default: {
      throw Error('Unknown env : ' + ENV)
    }
  }
}

const config: Config = {
  ENV,
  ...CommonConfig,
  ...EnvConfig(ENV),
}

const load = (env: Env) => {
  Object.assign(config, { ENV: env })
  Object.assign(config, CommonConfig)
  Object.assign(config, EnvConfig(env))
}

export default config
export { load, SERVER_PREFIXES, LINKS, HOTLINE_PHONE, VERSION_NAME }
